import request from '../Functions/ajax/request'

export default async function RechercheLoader ({ params })
{
	return { params, page: getPage({ params }) };
}

async function getPage ({ params })
{
	try
	{
		var { results } = await request('/articles/search')
		.config({ })
		.post({ searched: params.searched });
	}
	catch (e)
	{
		console.error(e);
	}

	return { results: results || [] };
}